import * as Sentry from '@sentry/nextjs'

export const IsDevEnv = process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_ENV_NAME === 'dev'

const environment = IsDevEnv ? 'development' : 'production'
export const SiteUrl = !!process.env.NEXT_PUBLIC_SITE_URL
  ? process.env.NEXT_PUBLIC_SITE_URL
  : 'http://localhost:3000/'

export const Settings = {
  AppName: 'Connect',
  CompanyName: 'Cocentric',
  Description: 'This is a template',

  AppConfig: {
    emailVerificationEnabled: true,
    signupCompleteVerificationEnabled: true,
  },

  Application: {
    IsBrowser: false,
    Domain: 'template.codeleap.co.uk',
  },

  Environment: {
    IsDev: IsDevEnv,
    Type: environment,
    InitTime: new Date(),
  },

  Stores: {
    AppleURL: 'https://apps.apple.com/us/app/',
    AndroidURL: 'https://play.google.com/store/',
  },

  Fetch: {
    ProductionURL: 'https://api.connectfrontline.com/',
    DevelopmentURL: 'https://api.cocentric-connect-dev.codeleap.co.uk/',
    ViewHTMLErrors: true,
  },

  Social: {
    FacebookURL: 'https://www.facebook.com/codeleapuk/',
    LinkedinURL: 'https://www.linkedin.com/company/codeleap-uk',
  },

  ContactINFO: {
    Website: 'codeleap.co.uk',
    TermsAndPrivacy: `https://cocentric.com/privacypolicy-connectapp`,
    Terms: `https://cocentric.com/privacypolicy-connectapp`,
    Privacy: `https://cocentric.com/privacypolicy-connectapp`,
    SupportEMAIL: 'support@cocentric.com',
    ContactEMAIL: 'hello@codeleap.co.uk',
    ContactPHONE: '+44 (0) 333 050 9420',
  },

  Logger: {
    performanceInspector: {
      enabled: IsDevEnv,
      maxRenders: 30,
      blacklist: [],
    },

    ignoreLogs: [
      `[react-native-gesture-handler] Seems like you're using`,
      `Require cycle:`,
      `Require cycles are allowed`,
      `Running `,
      `WARN  Require cycle`,
      ` Warning: Failed`,
      `Warning: Failed`,
      'new NativeEventEmitter',
      'User cancelled',
      'React does not recognize the',
      'Unknown event handler property',
      'forwardRef render functions accept exactly ',
      'Prop `className` did not match',
    ],
  },

  Slack: {
    echo: {
      icon: 'https://avatars.githubusercontent.com/u/48894125?s=200&v=4',
      token: 'xoxb-622265672359-1248324007429-Ts31vPT8jCNh7L99xtdbOgQB',
      channel: '#_dev_logs',
    },
  },

  Sentry: {
    dsn: 'https://e929273c465943e98c540b1839a72afb@o309198.ingest.sentry.io/4505370694975488',
    enabled: !IsDevEnv,
    provider: Sentry,
    initArgs: {
      environment,
      replaysSessionSampleRate: 0.2,
      tracesSampleRate: IsDevEnv ? 1.0 : 0.4,
      release: '1.0',
    },
  },

  ApiCredentials: {
    Gyphi: {
      ApiKey: 'g5XNBq6XGaRyHvN4awQPnZAhKbNTkrEB',
    },
    GoogleSignin: {
      WebClientId:
        '268760770384-ob7jfjntuorgqaj2tt2mvnqdokd634et.apps.googleusercontent.com',
    },
    AppleSignIn: {
      ServiceClientId: '',
      RedirectURI: '',
    },
    FacebookSDK: {
      AppId: '1130448934268035',
    },
  },

  Images: {
    Aspect: {
      default: 1,
    },
  },
  ConnectIDProd: {
    authorizationDomain: 'cocentricssoeu.onmicrosoft.com',
    accessHubAuthorizationDomain: 'login.cocentric.ai',
    clientId: '72f49c82-a295-4bf2-a796-49ef63031d50',
    clientSecret: '',
    redirectUri: `${SiteUrl}callback`,
    baseURL: '',
    scopes: 'https://cocentricssoeu.onmicrosoft.com/api/SSO.Read https://cocentricssoeu.onmicrosoft.com/api/SSO.Admin openid profile offline_access',
    authority:
      'https://cocentricssoeu.b2clogin.com/cocentricssoeu.onmicrosoft.com/b2c_1a_signin_usernameoremail',
    issuer:
      'https://cocentricssoeu.b2clogin.com/f2628327-584e-4b2f-8ea0-a0dcffa83a09/v2.0/',
    endpoints: {
      authorizationEndpoint:
        'https://cocentricssoeu.b2clogin.com/cocentricssoeu.onmicrosoft.com/b2c_1a_signin_usernameoremail/oauth2/v2.0/authorize',
      tokenEndpoint:
        'https://cocentricssoeu.b2clogin.com/cocentricssoeu.onmicrosoft.com/b2c_1a_signin_usernameoremail/oauth2/v2.0/token',
      logoutEndpoint:
        'https://cocentricssoeu.b2clogin.com/cocentricssoeu.onmicrosoft.com/b2c_1a_signin_usernameoremail/oauth2/v2.0/logout',
    },
  },
  ConnectID: {
    authorizationDomain: 'cocentricsso.b2clogin.com',
    accessHubAuthorizationDomain: 'login.cocentric.ai',
    clientId: '2c346382-7e9a-462d-b88d-3223c29d333b',
    clientSecret: '',
    redirectUri: `${SiteUrl}callback`,
    baseURL: '',
    scopes: 'https://cocentricsso.onmicrosoft.com/api/SSO.Read https://cocentricsso.onmicrosoft.com/api/SSO.Admin openid profile offline_access',
    authority:
      'https://cocentricsso.b2clogin.com/cocentricsso.onmicrosoft.com/B2C_1A_SIGNIN_USERNAMEOREMAIL',
    issuer:
      'https://cocentricsso.b2clogin.com/f2628327-584e-4b2f-8ea0-a0dcffa83a09/v2.0/',
    endpoints: {
      authorizationEndpoint:
        'https://cocentricsso.b2clogin.com/cocentricsso.onmicrosoft.com/B2C_1A_SIGNIN_USERNAMEOREMAIL/oauth2/v2.0/authorize',
      tokenEndpoint:
        'https://cocentricsso.b2clogin.com/cocentricsso.onmicrosoft.com/B2C_1A_SIGNIN_USERNAMEOREMAIL/oauth2/v2.0/token',
      logoutEndpoint:
        'https://cocentricsso.b2clogin.com/cocentricsso.onmicrosoft.com/b2c_1a_signin_usernameoremail/oauth2/v2.0/logout',
    },
  },
}
